import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { BlogService, BlogDetail, Blog } from '../../../services/blog.service';

@Component({
  selector: 'app-blog-details',
  templateUrl: './blog-details.component.html',
  styleUrls: ['./blog-details.component.scss']
})
export class BlogDetailsComponent implements OnInit {
  blogs: Blog[] = [];                         // For loading popular tags
  blog: BlogDetail | null = null;            // Detailed blog content
  loading = true;
  error = false;

  constructor(
    private route: ActivatedRoute,
    private blogService: BlogService,
    private titleService: Title,
    private metaService: Meta
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const slug = params.get('url');
      if (slug) {
        this.fetchBlogDetail(slug);
      }
    });

    this.loadAllBlogs(); 


     this.route.paramMap.subscribe(params => {
    const slug = params.get('url');
    if (slug) {
      this.fetchBlogDetail(slug);
    }
  });

  this.loadCategories();   
  this.loadAllBlogs(); 
  }

  fetchBlogDetail(slug: string): void {
    this.loading = true;
    this.error = false;
    this.blogService.getBlogDetailBySlug(slug).subscribe({
      next: (data) => {
        this.blog = data;
        this.updateMetaTags(data.metaTags);
        this.loading = false;
      },
      error: (err) => {
        this.error = true;
        this.loading = false;
      }
    });
  }

  loadAllBlogs(): void {
    this.blogService.getBlogs(1).subscribe({
      next: (res) => {
        this.blogs = res.blogs;
      },
      error: (err) => {
        console.error('Failed to load blogs for tags', err);
      }
    });
  }

  private updateMetaTags(metaTags: any[]): void {
    // Remove existing meta tags
    const tagsToRemove = [
      "name='description'", "name='keywords'", "name='author'",
      "property='og:title'", "property='og:description'", "property='og:image'",
      "property='og:url'", "property='og:type'", "name='twitter:card'",
      "name='twitter:title'", "name='twitter:description'", "name='twitter:image'",
      "rel='canonical'"
    ];

    tagsToRemove.forEach(selector => {
      this.metaService.removeTag(selector);
    });

    // Add new meta tags
    metaTags.forEach(tag => {
      if (tag.name === 'title') {
        this.titleService.setTitle(tag.content);
      } else if (tag.charset) {
        this.metaService.updateTag({ charset: tag.charset });
      } else if (tag['http-equiv']) {
        this.metaService.updateTag({ 'http-equiv': tag['http-equiv'], content: tag.content });
      } else if (tag.rel === 'canonical') {
        this.metaService.updateTag({ rel: 'canonical', href: tag.href });
      } else {
        const metaTag: any = {};
        if (tag.name) metaTag.name = tag.name;
        if (tag.property) metaTag.property = tag.property;
        if (tag.content) metaTag.content = tag.content;
        this.metaService.updateTag(metaTag);
      }
    });
  }

  categories: { name: string; count: number }[] = [];
  selectedCategory: string | null = null;

  // Optional: load all blogs again for filtering
  loadCategories(): void {
    this.blogService.getCategories().subscribe({
      next: (categories) => {
        this.categories = categories;
      },
      error: (err) => {
        console.error('Failed to load categories:', err);
      }
    });
  }

  filterByCategory(category: string | null): void {
    this.selectedCategory = category;

    // Optional: fetch filtered blogs
    this.blogService.getBlogs(1, this.selectedCategory || undefined).subscribe({
      next: (res) => {
        this.blogs = res.blogs;
      },
      error: (err) => {
        console.error('Error filtering blogs:', err);
      }
    });
  }

  getPopularTags(): string[] {
    const allTags = this.blogs.reduce((tags: string[], blog) => {
      return tags.concat(blog.tags || []);
    }, []);

    const tagCount = allTags.reduce((acc: { [key: string]: number }, tag) => {
      acc[tag] = (acc[tag] || 0) + 1;
      return acc;
    }, {});

    return Object.entries(tagCount)
      .sort(([, a], [, b]) => b - a)
      .slice(0, 10)
      .map(([tag]) => tag);
  }
}
